exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-classification .classification-comment{margin-top:.75rem}", ""]);

// exports
